/**
 * Reduces an array of signals based on the provided action.
 *
 * @param signals - An array of signal objects.
 * @param action - The action object to apply to the signals.
 * @returns A new array of signal objects with the updated state.
 */
var Reducer = function (signals, action) {
    var signalName = action.type.split("/")[0];
    // Loop through all signals, make updates on targeted states
    // and returns a new array of signals (immutability).
    return signals.map(function (_a) {
        var name = _a.name, operations = _a.operations, actions = _a.actions, asyncActions = _a.asyncActions, prevState = _a.state;
        var state = prevState;
        // Capture the target signal (a state and a bunch of actions) from the array of signals.
        // Capture the action from array of actions (of the target signal).
        // Run the action and update the signal state.
        if (name === signalName) {
            if (!action.isAsync) {
                for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
                    var _b = actions_1[_i], type = _b.type, handler = _b.handler;
                    if (type === action.type) {
                        state = handler(prevState, action.payload);
                        break;
                    }
                }
            }
            else {
                state = action.payload;
            }
        }
        return {
            name: name,
            operations: operations,
            state: state,
            actions: actions,
            asyncActions: asyncActions,
        };
    });
};
export default Reducer;
